import React from 'react';
import { c as classNames } from '../../../../../index-e609ebf3.js';
import '../../../../../_commonjsHelpers-17aad09c.js';

var ColHeaderBlockInner = function (_a) {
    var children = _a.children, isLeft = _a.isLeft, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, additionalRef = _a.additionalRef;
    var colHeaderBlockInnerClassNames = classNames('top-row-icon-block-inner', {
        left: isLeft,
        right: !isLeft,
    });
    return (React.createElement("div", { className: colHeaderBlockInnerClassNames, onClick: onClick, ref: additionalRef }, children));
};

export { ColHeaderBlockInner };
